var width = 0;
function resize(){
    if (document.body.clientWidth === width)
        return;
    width = document.body.clientWidth;
    angular.element(document.body).removeClass('screen-small screen-medium screen-large'); 
    if(width < 768) {
        angular.element(document.body).addClass('screen-small'); 
    } else if(width < 1024) {
        angular.element(document.body).addClass('screen-medium');             
    }
    else {
        angular.element(document.body).addClass('screen-large');             
    }
}
if(window.addEventListener){
    window.addEventListener('resize', resize);
}
else {
    document.body.onresize = resize;
}
resize();



// WEBPACK FOOTER //
// ./src/ie8.js